module.exports = __webpack_public_path__ + "img/pot3.6ce5c252.png";